import type { FaireProductEntity } from "../../entity_types/product";

export const p_1iob69nkq5: FaireProductEntity = {
  token: "p_1iob69nkq5",
  type: "product",
  name: "Classic Seed Crackers Gluten Free Organic Snacks 6 uni/case",
  brandToken: "b_apg589hg34",
  brandName: "Cult Crackers",
  imageUrl:
    "https://cdn.faire.com/fastly/34d24dc97292964d676194071ee60875b8ba027a52254dfa52d24109e287f050.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8f32244eae35e48ba992eb45f9bfd057da8f90848aecaf78e2e23df7287aeceb.jpeg",
    "https://cdn.faire.com/fastly/b582cd348c81a14f531309ae5017c660085a42991342e273f7af21fbb8524c77.jpeg",
    "https://cdn.faire.com/fastly/10d83e8cb35d378164391d285822d89a85de1b9d234caf712fd91abe2d98d788.jpeg",
    "https://cdn.faire.com/fastly/b5c500051b08ea63360cf7dd507149f57a87ddb23ba28269ba0ab07cc14c6dbf.jpeg",
    "https://cdn.faire.com/fastly/6bf76def641978e757e854194ff6795fe188bb4bc6125265eb19d89ae184595e.jpeg",
    "https://cdn.faire.com/fastly/e047c57ca4e83f4ce4b5ed80c52f0e84ad574fafebd69468c32ec58f91cdc973.jpeg",
  ],
  priceDollars: 4.99,
  description:
    "Our award-winning gluten free crackers are good for you. As a better-for-you food brand, we hand bake our insanely good crackers in small batches. They're packed with flavor and crunch from six powerhouse seeds. Eat them straight out of the bag or with your favorite fixings. They're a natural fit for gourmet & specialty grocery, markets, hotels, cheese shops, butcher shops, juice bars, cafe, restaurants, bakeries, fitness studio, yoga studios, mercantile, liquor store, grocery store, cheeseboards, appetizers, charcuterie boards, wine bars, winery, wineries and delis. \nPerfect for cheese and crackers on cheese boards, kid-friendly snacks, healthy snacks, organic snacks, whole 30, gluten-free, vegan, handmade, allergen-friendly, good for you, nutrient dense, healthy foods, high protein, high fiber. \nCALIFORNIA WARNING: Can expose you to cadmium, a carcinogen and reproductive toxicant. See www.P65Warnings.ca.gov/food",
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:19.996Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
